/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
function sortList(elem) {

  var ul = document.getElementById(elem);
  if( ul == null)
    return;
  Array.from(ul.getElementsByTagName("LI"))
  .sort((a, b) => a.textContent.trim().localeCompare(b.textContent.trim()))
  .forEach(li => ul.appendChild(li));
}

function sortListNew(elem){

  var ul = document.querySelector(elem);
  if(ul == null)
   return;
   
  var new_ul = ul.cloneNode(false);

  // Add all lis to an array
  var lis = [];
  for(var i = ul.childNodes.length; i--;){
    if(ul.childNodes[i].nodeName === 'LI'){
      lis.push(ul.childNodes[i]);
    }
  }

  // Sort the lis in descending order
  lis.sort(function(a, b){
    if( parseFloat(a.querySelector('label').textContent.match(/\d+(\.\d+)?/)[0])  < parseFloat(b.querySelector('label').textContent.match(/\d+(\.\d+)?/)[0]) ) { return -1; }
    if( parseFloat(a.querySelector('label').textContent.match(/\d+(\.\d+)?/)[0])  > parseFloat(b.querySelector('label').textContent.match(/\d+(\.\d+)?/)[0]) ) { return 1; }
    return 0;
  });

  // Add them into the ul in order
  for(var i = 0; i < lis.length; i++)
    new_ul.appendChild(lis[i]);
  ul.parentNode.replaceChild(new_ul, ul);
}

window.onload = (event) => {
  sortList("product-documents");
  sortList('Type');
  sortListNew("ul#Size");
};



